const RELOAD_KEY = "fluxabee-chunk-reload";
const RETRY_INTERVAL = 60_000;
const IMPORT_ERROR =
  /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS|Loading (?:CSS )?chunk .+ failed/i;

export const isChunkLoadError = (error: unknown): boolean => {
  if (typeof error === "string") return IMPORT_ERROR.test(error);
  if (!error || typeof error !== "object") return false;
  const { name, message } = error as { name?: unknown; message?: unknown };
  return name === "ChunkLoadError" ||
    (typeof message === "string" && IMPORT_ERROR.test(message));
};

/** One automatic retry per minute in this tab, shared by router and boot errors. */
export const recoverChunkLoadError = (error: unknown, destination?: string): boolean => {
  if (typeof window === "undefined" || !isChunkLoadError(error) ||
      window.navigator.onLine === false) return false;

  const target = new URL(destination ?? window.location.href, window.location.href);
  if (target.origin !== window.location.origin) return false;

  try {
    const lastAttempt = Number(window.sessionStorage.getItem(RELOAD_KEY));
    const now = Date.now();
    if (lastAttempt > 0 && now - lastAttempt < RETRY_INTERVAL) return false;
    // Persist before navigating. window.load does not prove React boot succeeded.
    window.sessionStorage.setItem(RELOAD_KEY, String(now));
  } catch {
    // Without durable storage we cannot guarantee that a reload will not loop.
    return false;
  }

  window.location.replace(target.href);
  return true;
};
